/**
 * Datos completos de productos Horeca
 * Incluye descripciones, ingredientes, formatos e información detallada
 */

export const horecaProductsData = {
  // CATEGORÍA 1: FORMATO BIBERÓN
  biberon: [
    {
      id: 'ketchup-biberon',
      name: 'Ketchup Intercasa Biberón',
      shortName: 'Ketchup Biberón',
      category: 'Formato Biberón',
      categorySlug: 'biberon',
      shortDescription: 'Ketchup de tomates seleccionados para hostelería.',
      description: 'Ketchup elaborado con tomates seleccionados y un sabor equilibrado, perfecto para el ritmo diario de cocinas profesionales y servicios de hostelería.',
      ingredients: 'Concentrado de tomate, azúcar, vinagre, sal, almidón modificado de maíz, estabilizantes (goma guar, goma garrofín, pectinas), conservador (benzoato sódico) y aromas.',
      formats: ['Biberón 900g'],
      formatDisplay: 'Biberón 900g',
      idealFor: 'Restaurantes, bares, cafeterías, servicios de comida rápida y establecimientos que necesitan un formato práctico y listo para servir.',
      productType: 'Horeca',
      image: '/images/productos/HORECA/Ketchup_biberón_900gr.webp',
      bannerImage: '/images/productos/BANNERS IDEAL PARA/ketchup-normal-zero.webp'
    },
    {
      id: 'mostaza-dulce-biberon',
      name: 'Mostaza Dulce Biberón',
      shortName: 'Mostaza Dulce Biberón',
      category: 'Formato Biberón',
      categorySlug: 'biberon',
      shortDescription: 'Mostaza dulce suave y equilibrada para hostelería.',
      description: 'Mostaza dulce de textura suave y sabor equilibrado, pensada para acompañar carnes, bocadillos y elaboraciones habituales en hostelería.',
      ingredients: 'Agua, azúcar, vinagre de alochol, harina de mostaza, estabilizantes (goma guar goma xantana y almidón modificado de maíz), sal, aceite de girasol, conservador (metabisulfito potásico y sorbato potásico) colorante (caramelo) y especias. Contiene dióxido de azufre y sulfitos en concentraciones superiores a 10mg/kg.',
      formats: ['Biberón 900g'],
      formatDisplay: 'Biberón 900g',
      idealFor: 'Bares, restaurantes, perritos calientes, bocadillos, carnes y platos que buscan un toque amable y ligeramente dulce.',
      productType: 'Horeca',
      image: '/images/productos/HORECA/Mostaza_dulce_biberón_900g.webp',
      bannerImage: '/images/productos/BANNERS IDEAL PARA/mostaza-dulce.webp'
    },
    {
      id: 'barbacoa-biberon',
      name: 'Salsa Barbacoa Biberón',
      shortName: 'Barbacoa Biberón',
      category: 'Formato Biberón',
      categorySlug: 'biberon',
      shortDescription: 'Salsa ahumada e intensa para carnes y hamburguesas.',
      description: 'Salsa barbacoa con notas ahumadas y un sabor intenso, ideal para carnes, hamburguesas y recetas donde se busca un acabado con carácter.',
      ingredients: 'Concentrado de tomate, azúcar, jarabe de melaza, vinagre de alcohol, sal, almidón modificado de maíz, aroma de humo, estabilizante (goma guar), conservador (benzoato sódico), especias y aromas.',
      formats: ['Biberón 900g'],
      formatDisplay: 'Biberón 900g',
      idealFor: 'Hamburgueserías, parrillas, cocinas profesionales y locales que requieren una salsa lista para usar con sabor potente.',
      productType: 'Horeca',
      image: '/images/productos/HORECA/Barbacoa_biberón_900g.webp',
      bannerImage: '/images/productos/BANNERS IDEAL PARA/Barbacoa.webp'
    },
    {
      id: 'alioli-biberon',
      name: 'Alioli Receta Canaria',
      shortName: 'Alioli',
      category: 'Formato Biberón',
      categorySlug: 'biberon',
      shortDescription: 'Alioli de receta canaria en formato biberón para hostelería.',
      description: 'Alioli elaborado con ajo natural y perejil siguiendo la receta canaria, con una textura cremosa y un sabor intenso, en un formato biberón práctico y listo para servir.',
      ingredients: 'Aceite de girasol (64%), agua, huevo y yema de huevo(6,5%), ajo natural (4,8%), vinagre de vino blanco, azúcar, perejil, sal, almidón modificado de maíz, estabilizante (goma garrofín), zumo de limón, conservador (sorbato potásico), mostaza, acidulante (ácido cítrico), antioxidante (EDTA), colorante (betacaroteno) y aromas.',
      formats: ['Biberón 643ml'],
      formatDisplay: '643ml',
      idealFor: 'Asadores, restaurantes, bares, guachinches y locales que buscan un alioli auténtico en un formato práctico de servicio directo.',
      productType: 'Horeca',
      image: '/images/productos/HORECA/Alioli_biberón_643ml.webp',
      imageScale: 0.88,
      bannerImage: '/images/productos/BANNERS IDEAL PARA/Alioli.webp'
    }
  ],

  // CATEGORÍA 2: FORMATO GARRAFA
  garrafa: [
    {
      id: 'ketchup-garrafa',
      name: 'Ketchup Intercasa Garrafa',
      shortName: 'Ketchup Garrafa',
      category: 'Formato Garrafa',
      categorySlug: 'garrafa',
      shortDescription: 'Ketchup para cocinas con alto volumen de producción.',
      description: 'Ketchup elaborado con tomates seleccionados, pensado para cocinas profesionales que necesitan un producto estable, sabroso y fácil de utilizar en gran volumen.',
      ingredients: 'Concentrado de tomate, azúcar, vinagre, sal, almidón modificado de maíz, estabilizantes (goma guar, goma garrofín, pectinas), conservador (benzoato sódico) y aromas.',
      formats: ['Garrafa 1.850g', 'Garrafa 5.000g'],
      formatDisplay: 'Garrafa 1.850g | 5.000g',
      idealFor: 'Cocinas industriales, comedores, restaurantes, caterings y establecimientos con alto consumo de salsa.',
      productType: 'Horeca',
      image: '/images/productos/HORECA/Ketchup_garrafa_1850gr.webp',
      bannerImage: '/images/productos/BANNERS IDEAL PARA/ketchup-normal-zero.webp'
    },
    {
      id: 'mostaza-dulce-garrafa',
      name: 'Mostaza Dulce Garrafa',
      shortName: 'Mostaza Dulce Garrafa',
      category: 'Formato Garrafa',
      categorySlug: 'garrafa',
      shortDescription: 'Mostaza dulce para uso profesional en grandes cantidades.',
      description: 'Mostaza dulce con un sabor suave y equilibrado, perfecta para uso profesional en bocadillos, carnes y preparaciones rápidas.',
      ingredients: 'Agua, azúcar, vinagre de alochol, harina de mostaza, estabilizantes (goma guar goma xantana y almidón modificado de maíz), sal, aceite de girasol, conservador (metabisulfito potásico y sorbato potásico) colorante (caramelo) y especias. Contiene dióxido de azufre y sulfitos en concentraciones superiores a 10mg/kg.',
      formats: ['Garrafa 1.850g'],
      formatDisplay: 'Garrafa 1.850g',
      idealFor: 'Bares, restaurantes, food trucks y negocios que requieren formatos grandes y prácticos.',
      productType: 'Horeca',
      image: '/images/productos/HORECA/Mostaza_dulce_garrafa_1850g.webp',
      bannerImage: '/images/productos/BANNERS IDEAL PARA/mostaza-dulce.webp'
    },
    {
      id: 'barbacoa-garrafa',
      name: 'Salsa Barbacoa Garrafa',
      shortName: 'Barbacoa Garrafa',
      category: 'Formato Garrafa',
      categorySlug: 'garrafa',
      shortDescription: 'Barbacoa ahumada para cocinas profesionales.',
      description: 'Salsa barbacoa de sabor intenso y un toque ahumado, elaborada pensando en cocinas profesionales que buscan consistencia y rendimiento en grandes cantidades.',
      ingredients: 'Concentrado de tomate, azúcar, jarabe de melaza, vinagre de alcohol, sal, almidón modificado de maíz, aroma de humo, estabilizante (goma guar), conservador (benzoato sódico), especias y aromas.',
      formats: ['Garrafa 1.850g'],
      formatDisplay: 'Garrafa 1.850g',
      idealFor: 'Parrillas, hamburgueserías, caterings y locales con alta demanda de salsa barbacoa.',
      productType: 'Horeca',
      image: '/images/productos/HORECA/Barbacoa_garrafa_1850g.webp',
      bannerImage: '/images/productos/BANNERS IDEAL PARA/Barbacoa.webp'
    }
  ],

  // CATEGORÍA 3: FORMATO CUBO
  cubo: [
    {
      id: 'ketchup-cubo',
      name: 'Ketchup Intercasa Cubo',
      shortName: 'Ketchup Cubo',
      category: 'Formato Cubo',
      categorySlug: 'cubo',
      shortDescription: 'Ketchup para grandes cantidades con rendimiento constante.',
      description: 'Ketchup elaborado con tomates seleccionados y un sabor equilibrado, pensado para cocinas profesionales que requieren grandes cantidades con un rendimiento constante.',
      ingredients: 'Concentrado de tomate, azúcar, vinagre, sal, almidón modificado de maíz, estabilizantes (goma guar, goma garrofín, pectinas), conservador (benzoato sódico) y aromas.',
      formats: ['Cubo 5.000g'],
      formatDisplay: 'Cubo 5.000g',
      idealFor: 'Cocinas industriales, comedores, caterings y establecimientos con alto volumen de preparación.',
      productType: 'Horeca',
      image: '/images/productos/HORECA/Ketchup_cubo_5000gr.webp',
      formatImages: {
        'Cubo 5.000g': '/images/productos/HORECA/Ketchup_cubo_5000gr.webp'
      },
      bannerImage: '/images/productos/BANNERS IDEAL PARA/ketchup-normal-zero.webp'
    },
    {
      id: 'mostaza-dulce-cubo',
      name: 'Mostaza Dulce Cubo',
      shortName: 'Mostaza Dulce Cubo',
      category: 'Formato Cubo',
      categorySlug: 'cubo',
      shortDescription: 'Mostaza versátil para hostelería en formato grande.',
      description: 'Mostaza dulce de textura suave y sabor equilibrado, ideal para hostelería y restauración que necesitan una salsa versátil y en formato grande.',
      ingredients: 'Agua, azúcar, vinagre de alcohol, harina de mostaza, aceite de girasol, sal, especias, estabilizantes (goma guar, goma xantana, goma garrofín, pectinas), aromas (apio) y conservadores (benzoato de sodio y sorbato de potasio).',
      formats: ['Cubo 5.000g'],
      formatDisplay: 'Cubo 5.000g',
      idealFor: 'Restaurantes, bares, áreas de servicio y negocios de comida rápida.',
      productType: 'Horeca',
      image: '/images/productos/HORECA/Mostaza_dulce_cubo_5000g.webp',
      bannerImage: '/images/productos/BANNERS IDEAL PARA/mostaza-dulce.webp'
    },
    {
      id: 'barbacoa-cubo',
      name: 'Salsa Barbacoa Cubo',
      shortName: 'Barbacoa Cubo',
      category: 'Formato Cubo',
      categorySlug: 'cubo',
      shortDescription: 'Barbacoa ahumada estable para gran volumen.',
      description: 'Salsa barbacoa con notas ahumadas y un sabor intenso, formulada para cocinas profesionales que buscan una salsa estable y lista para usar en gran volumen.',
      ingredients: 'Concentrado de tomate, azúcar, jarabe de melaza, vinagre de alcohol, sal, almidón modificado de maíz, aroma de humo, estabilizante (goma guar), conservador (benzoato sódico), especias y aromas.',
      formats: ['Cubo 5.000g'],
      formatDisplay: 'Cubo 5.000g',
      idealFor: 'Parrillas, hamburgueserías, caterings y establecimientos de comida americana o tex-mex.',
      productType: 'Horeca',
      image: '/images/productos/HORECA/Barbacoa_cubo_5000g.webp',
      formatImages: {
        'Cubo 5.000g': '/images/productos/HORECA/Barbacoa_cubo_5000g.webp'
      },
      bannerImage: '/images/productos/BANNERS IDEAL PARA/Barbacoa.webp'
    }
  ],

  // CATEGORÍA 4: FORMATO LATA
  lata: [
    {
      id: 'ketchup-lata',
      name: 'Ketchup Intercasa Lata',
      shortName: 'Ketchup Lata',
      category: 'Formato Lata',
      categorySlug: 'lata',
      shortDescription: 'Ketchup elaborado con tomates seleccionados para cocinas profesionales.',
      description: 'Ketchup elaborado con tomates seleccionados y un sabor para cocinas profesionales.',
      ingredients: 'Concentrado de tomate, azúcar, vinagre de alcohol, sal, almidón modificado de maíz, estabilizantes (goma guar), conservador (benzoato sódico) y aromas.',
      formats: ['Lata 4.350g'],
      formatDisplay: 'Lata 4.350g',
      idealFor: 'Cocinas industriales, restaurantes, comedores colectivos y servicios de restauración con alto consumo.',
      productType: 'Horeca',
      image: '/images/productos/HORECA/Ketchup_lata_4350g.webp',
      bannerImage: '/images/productos/BANNERS IDEAL PARA/ketchup-normal-zero.webp'
    },
    {
      id: 'salsa-pizza-lata',
      name: 'Salsa Pizza Lata',
      shortName: 'Salsa Pizza Lata',
      category: 'Formato Lata',
      categorySlug: 'lata',
      shortDescription: 'Salsa de tomate diseñada para pizzas con textura homogénea.',
      description: 'Salsa de tomate diseñada para pizzas, con textura homogénea y un sabor equilibrado.',
      ingredients: 'Tomate, almidón de maíz modificado, sal, azúcar, aceite de girasol, acidulante: ácido cítrico, cebolla, albahaca y orégano.',
      formats: ['Lata 2.550g'],
      formatDisplay: 'Lata 2.550g',
      idealFor: 'Pizzerías, cocinas profesionales, hornos industriales y establecimientos especializados en pizza.',
      productType: 'Horeca',
      image: '/images/productos/HORECA/Salsa_pizza_lata_2550g.webp',
      bannerImage: '/images/productos/BANNERS IDEAL PARA/ketchup-normal-zero.webp'
    },
    {
      id: 'tomate-frito-lata',
      name: 'Tomate Frito Intercasa Lata',
      shortName: 'Tomate Frito Lata',
      category: 'Formato Lata',
      categorySlug: 'lata',
      shortDescription: 'Tomate frito listo para usar en cocinas profesionales.',
      description: 'Tomate frito listo para usar para cocinas profesionales.',
      ingredients: 'Agua, concentrado de tomate, almidón modificado de maíz, aceite de girasol, azúcar, sal, cebolla molida, ajo molido, conservador (benzoato sódico), antioxidante (ácido cítrico) y zumo de zanahoria negra.',
      formats: ['Lata 2.550g'],
      formatDisplay: 'Lata 2.550g',
      idealFor: 'Restaurantes, comedores, caterings y preparaciones de salsas, guisos y platos elaborados.',
      productType: 'Horeca',
      image: '/images/productos/HORECA/Tomate_frito_lata_2550g.webp',
      bannerImage: '/images/productos/BANNERS IDEAL PARA/ketchup-normal-zero.webp'
    },
    {
      id: 'concentrado-tomate-lata',
      name: 'Doble Concentrado de Tomate Lata',
      shortName: 'Doble Concentrado Lata',
      category: 'Formato Lata',
      categorySlug: 'lata',
      shortDescription: 'Concentrado de tomate para reforzar color y sabor en recetas.',
      description: 'Concentrado de tomate para reforzar color y sabor en recetas profesionales.',
      ingredients: 'Tomates, sal y ácido cítrico.',
      formats: ['Lata 400g', 'Lata 4.540g'],
      formatDisplay: 'Lata 400g | 4.540g',
      idealFor: 'Cocinas profesionales, salsas, fondos, guisos y elaboraciones que necesitan un punto de tomate más intenso.',
      productType: 'Horeca',
      image: '/images/productos/HORECA/Concentrado_tomate_lata_4540g.webp',
      formatImages: {
        'Lata 400g': '/images/productos/HORECA/Concentrado_tomate_lata_4540g.webp',
        'Lata 4.540g': '/images/productos/HORECA/Concentrado_tomate_lata_4540g.webp'
      },
      bannerImage: '/images/productos/BANNERS IDEAL PARA/ketchup-normal-zero.webp'
    },
    {
      id: 'tomate-pelado-lata',
      name: 'Tomate Entero Pelado Lata',
      shortName: 'Tomate Pelado Lata',
      category: 'Formato Lata',
      categorySlug: 'lata',
      shortDescription: 'Tomates enteros pelados conservados en su jugo.',
      description: 'Tomates enteros pelados y conservados en su jugo para recetas profesionales.',
      ingredients: 'Tomate, jugo de tomate, sal, acidulante: ácido cítrico y endurecedor: cloruro cálcico.',
      formats: ['Lata 4.000g'],
      formatDisplay: 'Lata 4.000g',
      idealFor: 'Restaurantes, pizzerías, cocinas industriales y elaboraciones que parten del tomate entero.',
      productType: 'Horeca',
      image: '/images/productos/HORECA/Tomate_pelado_lata_4000g.webp',
      bannerImage: '/images/productos/BANNERS IDEAL PARA/ketchup-normal-zero.webp'
    },
    {
      id: 'tomate-triturado-lata',
      name: 'Tomate Triturado Lata',
      shortName: 'Tomate Triturado Lata',
      category: 'Formato Lata',
      categorySlug: 'lata',
      shortDescription: 'Tomate triturado de textura uniforme para salsas y guisos.',
      description: 'Tomate triturado de textura uniforme, ideal como base para salsas, guisos y recetas profesionales de gran volumen.',
      ingredients: 'Tomate, sal y acidulante: ácido cítrico.',
      formats: ['Lata 4.000g'],
      formatDisplay: 'Lata 4.000g',
      idealFor: 'Cocinas industriales, restaurantes, caterings y preparaciones de salsas y fondos.',
      productType: 'Horeca',
      image: '/images/productos/HORECA/Tomate_triturado_lata_4000g.webp',
      bannerImage: '/images/productos/BANNERS IDEAL PARA/ketchup-normal-zero.webp'
    }
  ],

  // CATEGORÍA 5: MAYONESAS Y ALIOLI EN CUBO
  mayonesasAlioli: [
    {
      id: 'mayonesa-cubo',
      name: 'Mayonesa Intercasa Cubo',
      shortName: 'Mayonesa Cubo',
      category: 'Mayonesas y Alioli en Cubo',
      categorySlug: 'mayonesas-alioli',
      shortDescription: 'Mayonesa versátil de gran rendimiento profesional.',
      description: 'Mayonesa de textura suave y sabor equilibrado, ideal para cocinas profesionales que necesitan un producto versátil y de gran rendimiento.',
      ingredients: 'Aceite de girasol (64%), agua, huevo y yema de huevo (6,5%), vinagre de vino blanco, azúcar, sal, almidón modificado de maíz, estabilizante (goma garrofín), zumo de limón, conservador (sorbato potásico), mostaza, acidulante (ácido cítrico), antioxidante (EDTA), colorante (betacaroteno) y aromas.',
      formats: ['Cubo 5.000ml', 'Cubo 10.000ml'],
      formatDisplay: 'Cubo 5.000ml | 10.000ml',
      idealFor: 'Caterings, cocinas industriales, comedores, obradores y establecimientos con alto volumen de producción.',
      productType: 'Horeca',
      image: '/images/productos/HORECA/Mayonesa_cubo_5000ml.webp',
      formatImages: {
        'Cubo 5.000ml': '/images/productos/HORECA/Mayonesa_cubo_5000ml.webp',
        'Cubo 10.000ml': '/images/productos/HORECA/Mayonesa_cubo_10000ml.webp'
      },
      bannerImage: '/images/productos/BANNERS IDEAL PARA/Mayonesa.webp'
    },
    {
      id: 'mayonesa-ligera-cubo',
      name: 'Mayonesa Ligera Cubo',
      shortName: 'Mayonesa Ligera Cubo',
      category: 'Mayonesas y Alioli en Cubo',
      categorySlug: 'mayonesas-alioli',
      shortDescription: 'Opción ligera para profesionales sin perder calidad.',
      description: 'Versión ligera de nuestra mayonesa clásica, con textura suave y un sabor equilibrado, pensada para profesionales que buscan una opción más ligera sin perder calidad.',
      ingredients: 'Agua, Aceite de Soja genéticamente modificada (30%), Vinagre, Almidón modificado de maíz, Azúcar, Sal, Huevo (0,85%), Estabilizantes (goma xantana), Zumo de limón, Conservador (benzoato sódico), Acidulante (ácido cítrico), Antioxidante (EDTA), Colorante (Betacaroteno) y Aromas.',
      formats: ['Cubo 10.000ml'],
      formatDisplay: 'Cubo 10.000ml',
      idealFor: 'Cocinas profesionales, caterings y negocios que buscan alternativas más ligeras para su menú.',
      productType: 'Horeca',
      image: '/images/productos/HORECA/Salsa_fina_cubo_10000ml.webp',
      bannerImage: '/images/productos/BANNERS IDEAL PARA/Mayonesa.webp'
    },
    {
      id: 'alioli-receta-canaria-cubo',
      name: 'Alioli Receta Canaria Cubo',
      shortName: 'Alioli Receta Canaria Cubo',
      category: 'Mayonesas y Alioli en Cubo',
      categorySlug: 'mayonesas-alioli',
      shortDescription: 'Alioli auténtico canario para hostelería.',
      description: 'Alioli de receta canaria con un sabor característico, perfecto para acompañar carnes, papas y platos tradicionales, adaptado al uso profesional en hostelería.',
      ingredients: 'Aceite de girasol (64%), agua, huevo y yema de huevo(6,5%), ajo natural (4,8%), vinagre de vino blanco, azúcar, perejil, sal, almidón modificado de maíz, estabilizante (goma garrofín), zumo de limón, conservador (sorbato potásico), mostaza, acidulante (ácido cítrico), antioxidante (EDTA), colorante (betacaroteno) y aromas.',
      formats: ['Cubo 1.850ml'],
      formatDisplay: 'Cubo 1.850ml',
      idealFor: 'Asadores, restaurantes, bares, guachinches, caterings y locales que buscan un alioli auténtico y de sabor intenso.',
      productType: 'Horeca',
      image: '/images/productos/HORECA/Alioli_cubo_1850ml.webp',
      bannerImage: '/images/productos/BANNERS IDEAL PARA/Alioli.webp'
    }
  ]
};

/**
 * Obtiene todos los productos horeca en un array plano
 * @returns {Array} Array con todos los productos
 */
export const getAllHorecaProducts = () => {
  return [
    ...horecaProductsData.biberon,
    ...horecaProductsData.garrafa,
    ...horecaProductsData.cubo,
    ...horecaProductsData.lata,
    ...horecaProductsData.mayonesasAlioli
  ];
};

/**
 * Busca un producto horeca por su ID
 * @param {string} productId - ID del producto
 * @returns {Object|null} Producto encontrado o null
 */
export const getHorecaProductById = (productId) => {
  const allProducts = getAllHorecaProducts();
  return allProducts.find(product => product.id === productId) || null;
};

/**
 * Obtiene productos horeca por categoría
 * @param {string} categorySlug - Slug de la categoría
 * @returns {Array} Array de productos de la categoría
 */
export const getHorecaProductsByCategory = (categorySlug) => {
  const categoryMap = {
    'biberon': horecaProductsData.biberon,
    'garrafa': horecaProductsData.garrafa,
    'cubo': horecaProductsData.cubo,
    'lata': horecaProductsData.lata,
    'mayonesas-alioli': horecaProductsData.mayonesasAlioli
  };
  return categoryMap[categorySlug] || [];
};